import { render } from "./FuncaoIndex.vue?vue&type=template&id=4e58cb31&ts=true"
import script from "./FuncaoIndex.vue?vue&type=script&lang=ts"
export * from "./FuncaoIndex.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__